export default {
  socialMedia: (state) => {
    return state.recorded.socialMediaReviews
  }
}
